import { AutogenLayoutTariffRegionExpireRows } from "./autogen/AutogenLayoutTariffRegionExpireRows";

export class TariffRegionExpireRows extends AutogenLayoutTariffRegionExpireRows {

}
